$(document).ready(function () {

    /* $('.cr_our_values').on("setPosition", function() {
        $('.valuecard_con').each(function(){
            var currDataIndex = $(this).attr('data-slick-index');
            if(currDataIndex > 0){
                $(this).addClass('right_slide');
            }else{
                $(this).removeClass('right_slide');
            }
        });

        
    });
    $('.cr_our_values').on("afterChange", function() {
        $('.slick-current').removeClass('right_slide');
    }); */
    $('.cr_our_values').slick({
        dots: false,
        infinite: true,
        slidesToShow: 3,
        centerMode: true,
        autoplay: true,
        centerPadding: '0px',
        speed: 500,
        autoplaySpeed: 3000,
        dots: false,
        arrows: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1480,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '350px',
                }   
            },
            {
                breakpoint: 1250,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '300px',
                }   
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '250px',
                }   
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '150px',
                }   
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '100px',
                }   
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '50px',
                }   
            },
            {
                breakpoint: 380,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '20px',
                }   
            }
        ]
    })
    
    /* $('.emp_power_con').on("init", function() {
        console.log($('.emp_power_con').find('.slick-track').innerHeight());
    }); */

   

    $('.emp_power_con').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        autoplay: false,
        infinite: true,
        centerMode: true,
        centerPadding: '120px',
        speed: 500,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '100px',
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '200px',
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 1,
                    centerPadding:'150px',
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerPadding:'100px',
                }
            },
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    centerPadding:'0px',
                }
            }
        ]
    }).on('setPosition', function (event, slick) {
        var trackHT = slick.$slideTrack.find('.emp_power_blurb').innerHeight();
        $('.emp_power_con').css({height: trackHT+100 + 'px'});
    });

    /* $('.emp_power_con').on("setPosition", function () {
        resizeSlider(slickHeight);
    });

    var slickHeight = $(".emp_power_con .slick-track").innerHeight();
    setTimeout(function () {
        slickHeight = $(".emp_power_con .slick-track").innerHeight();
    }, 10);

    $(window).on("resize", function (e) {
        setTimeout(function () {
            slickHeight = $(".emp_power_con .slick-track").innerHeight();
            resizeSlider(slickHeight);
            $('.emp_power_con').slick("resize");
        }, 1000);
    });

    function resizeSlider(stHT) {
        $(".slick-track").find(".emp_power_blurb").css({ height: stHT + 'px' });
    } */
});
